import { c as _c } from "react/compiler-runtime";
import { useEffect, useMemo } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { useAtom } from 'jotai';
import useLocationHash from '../../src/hooks/useLocationHash';
import locationStateAtom from './locationStateBridge';
const useLocationMock = () => {
  const $ = _c(10);
  const pathname = usePathname();
  const searchParamsObject = useSearchParams();
  let t0;
  if ($[0] !== searchParamsObject) {
    t0 = searchParamsObject.toString();
    $[0] = searchParamsObject;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const searchParamsString = `?${t0}`;
  const hash = useLocationHash();
  const [state, setState] = useAtom(locationStateAtom);
  let t1;
  let t2;
  if ($[2] !== setState) {
    t1 = () => {
      const handlePopState = () => {
        setState(null);
      };
      window.addEventListener("popstate", handlePopState);
      return () => window.removeEventListener("popstate", handlePopState);
    };
    t2 = [setState];
    $[2] = setState;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  const t3 = pathname || "";
  let t4;
  if ($[5] !== hash || $[6] !== searchParamsString || $[7] !== state || $[8] !== t3) {
    t4 = {
      hash,
      pathname: t3,
      search: searchParamsString,
      state
    };
    $[5] = hash;
    $[6] = searchParamsString;
    $[7] = state;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const location = t4;
  return location;
};
export default useLocationMock;